var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":"","nav":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('left-navigation-menu-header-image')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }